import React from 'react'
import { Row, Col, Radio, DatePicker } from 'antd'
import Dropdown from 'react-dropdown'
import { initialNational } from 'utils/constants'
import { get } from 'lodash'
import { useMediaQuery } from 'react-responsive'

import Input from 'component/Input'
import { renderColValue } from 'utils/helper'

const FirstMedia = ({ formik, editable, userProfile, userData }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const isEditOnMobile = editable && isMobile

  const name = get(userProfile, 'name', '') || get(userData, 'partner.name', '')
  const gender = get(userProfile, 'gender', '')
  const nationality = get(userProfile, 'nationality', '')
  const postalAddress = get(userProfile, 'postal_address', '')
  const postalCode = get(userProfile, 'postal_code', '')
  const passport = get(userProfile, 'passport', '')
  const phone = get(userProfile, 'phone', '')
  const birthDay = get(userProfile, 'birthday', '')

  const handleChangePhoneNum = ({ currentTarget }) => {
    var regExp = /^[0-9]{1,13}$/

    if (regExp.test(currentTarget.value) || currentTarget.value === '') {
      formik.setFieldValue('phone', currentTarget.value)
    }
  }

  return (
    <div>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          NAME (ACCORDING TO ID/PASSPORT):
        </Col>
        <Col
          xs={renderColValue(24, 10, isEditOnMobile)}
          md={6}
          className="profile__text"
        >
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="name"
                placeHolder="Enter your full name"
                formik={formik}
                value={formik.values.name}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            name
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          Gender:
        </Col>
        <Col
          md={6}
          xs={renderColValue(24, 10, isEditOnMobile)}
          className="profile__text"
        >
          {editable ? (
            <Radio.Group
              onChange={(e) => formik.setFieldValue('gender', e.target.value)}
              value={formik.values.gender}
              name="add-course__radio-type"
            >
              <Radio value="male">Male</Radio>
              <Radio value="female">Female</Radio>
            </Radio.Group>
          ) : (
            gender
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          Nationality:
        </Col>
        <Col md={6} className="profile__text" xs={renderColValue(24, 10)}>
          {editable ? (
            <div className="profile__field__wrapper">
              <Dropdown
                options={initialNational}
                onChange={(value) =>
                  formik.setFieldValue('nationality', value.label)
                }
                value={formik.values.nationality}
                placeholder="Select Nationality"
                className="dropdownScheduleModal"
              />

              {formik.values.nationality === 'Other' && (
                <div style={{ marginTop: 20 }}>
                  <Input
                    name="other_nationality"
                    placeHolder="Type another nationality here"
                    formik={formik}
                    value={formik.values.other_nationality}
                    onChange={formik.handleChange}
                    style={{ padding: 8 }}
                  />
                </div>
              )}
            </div>
          ) : (
            nationality
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          ID/Passport No. (eg. NRIC):
        </Col>
        <Col md={6} xs={10} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="passport"
                placeHolder="Enter ID/Passport"
                formik={formik}
                value={formik.values.passport}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            passport
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          Postal Address:
        </Col>
        <Col
          md={6}
          xs={renderColValue(24, 10, isEditOnMobile)}
          className="profile__text"
        >
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="address"
                placeHolder="Enter Postal Address"
                formik={formik}
                value={formik.values.address}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            postalAddress
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          Postal Code:
        </Col>
        <Col
          md={6}
          className="profile__text"
          xs={renderColValue(24, 10, isEditOnMobile)}
        >
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="postTalCode"
                placeHolder="Enter Postal Code"
                formik={formik}
                value={formik.values.postTalCode}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            postalCode
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Date of Birth:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <DatePicker
                onChange={(date, dateString) => {
                  formik.setFieldValue('date_of_birth', date)
                }}
                allowClear
                value={
                  formik.values.date_of_birth
                    ? formik.values.date_of_birth
                    : null
                }
                placeholder="Date of Birth"
                className="sc-modal__datepicker"
                style={{ width: '100%' }}
              />
            </div>
          ) : (
            birthDay
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12, isEditOnMobile)}
        >
          Phone No.:
        </Col>
        <Col
          md={6}
          xs={renderColValue(24, 10, isEditOnMobile)}
          className="profile__text"
        >
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="phone"
                placeHolder="Enter Phone No."
                formik={formik}
                value={formik.values.phone}
                onChange={handleChangePhoneNum}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            phone
          )}
        </Col>
      </Row>
    </div>
  )
}

export default FirstMedia
